import gql from 'graphql-tag';

export default gql`
  mutation deleteDraft($id: UUID!) {
    deleteDraft(_id: $id)
  }
`;
